import React from 'react'
import PropTypes from 'prop-types'
import { logError } from 'tools/logging'

class DataErrorBoundary extends React.Component {
  state = {
    hasError: false,
  }

  componentDidCatch (error, info) {
    this.setState({ hasError: true })
    logError(`Error in Data Boundary: ${error.message}`)
  }

  render () {
    if (this.state.hasError) {
      return null
    }
    return this.props.children
  }
}

DataErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
}

export default DataErrorBoundary



// WEBPACK FOOTER //
// ./src/atoms/DataErrorBoundary/DataErrorBoundary.js